import { useRef, useState, useEffect } from "react";
import { Button, styled } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface SearchComponentProps {
    fetchData: () => void; // fetchData fonksiyonunun tipi belirtildi
    onTemizle: () => void
    setData: React.Dispatch<React.SetStateAction<any[]>>;
    className?: string;

}
export const CustomButton = styled(Button)(({ theme, color }) => ({
    height: '2.4rem',
    backgroundColor: color,
    '&:hover': {
        backgroundColor: color,
    },

}));

const SearchComponent: React.FC<SearchComponentProps> = ({ fetchData, onTemizle, setData }) => {
    const recaptchaTokenRef: any = useRef();
    const theme = useTheme();
    const [countdown, setCountdown] = useState<number>(-1);
    const COUNTDOWN_DURATION = 3;

    // Countdown için useEffect: countdown > 0 iken her saniye bir azaltır, countdown = 0 ise buton aktif
    useEffect(() => {
        if (countdown < 0) return;
        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 0) {
                    clearInterval(timer);
                    return -1;
                }
                return prev - 1;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [countdown]);


    const handleSearch = async () => {
        if (countdown >= 0) return;

        // Butonu devre dışı bırakmak için countdown başlatılır (örneğin 5 saniye)
        setCountdown(COUNTDOWN_DURATION);
        fetchData();
    };


    const handleClick = () => {
        onTemizle();
        setData([]);

    };

    return (
        <div >

            <div className="d-flex flex-row gap-2">
                <CustomButton
                    color="primary"
                    onClick={handleSearch}
                    disabled={countdown >= 0}
                    sx={{ position: 'relative', overflow: 'hidden' }}
                >
                    {/* Sabit ikon */}
                    <i
                        style={{ fontSize: "1.2rem", position: 'relative', zIndex: 1 }}
                        className="fa fa-search text-white"
                    />

                    {/* Eğer countdown > 0 ise soldan sağa dolan overlay */}
                    {countdown >= 0 && (
                        <span
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: `${((COUNTDOWN_DURATION - countdown) / COUNTDOWN_DURATION) * 100}%`,
                                height: '100%',
                                 backgroundColor:theme.palette.primary.main,

                                transition: 'width 1s linear',
                                pointerEvents: 'none'
                            }}
                        />
                    )}

                </CustomButton>

                <CustomButton color="secondary" onClick={handleClick}>
                    <i style={{ fontSize: "1.2rem" }} className="fa fa-trash" />
                </CustomButton>
            </div>

        </div>
    )
}

export default SearchComponent

